import { AxiosError } from 'axios';
import instance from '../config/axios';

export const fetchTrackingInfoPatient = async (
  accessToken: string,
  orderId: number,
) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/patient/order/tracking/${orderId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};
